module.exports = __webpack_public_path__ + "static/media/paper.5e4a9b73.png";